import { LicenseStatusPanel } from '~bank-crb-monitor/components/LicenseStatusPanel'

import { useCRBPanelContext } from '../../CRBPanelContext'
import { License } from './License'

export const LicenseList = () => {
  const { data } = useCRBPanelContext()
  const { licenses } = data

  return (
    <>
      <LicenseStatusPanel showHintType={data.showHintType} showHintMessage={data.showHintMessage} />
      <h4 style={{ marginBottom: 20, marginTop: 8 }}>Select the license you want to connect</h4>

      {licenses.map((license) => {
        const { id } = license

        return <License license={license} key={id} />
      })}
    </>
  )
}
